import React, { useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom"; // <- uncomment if you use react-router
import EnrollImg from '../../../src/assets/Enroll.png';
import { useNavigate } from "react-router-dom";

const EnRoll = ({ enroll, setEnRollCourse }) => {
    const modalRef = useRef(null);
    const firstButtonRef = useRef(null);
    const navigate = useNavigate();
    // const navigate = useNavigate(); // if using react-router

    useEffect(() => {
        // focus first actionable element for accessibility
        firstButtonRef.current?.focus();

        // ESC to close
        const onKey = (e) => {
            if (e.key === "Escape") setEnRollCourse(null);
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [setEnRollCourse]);

    // close when clicking on backdrop
    const onBackdropClick = (e) => {
        if (e.target === e.currentTarget) setEnRollCourse(null);
    };

    // handlers for actions (replace with real logic)
    const handleSignUp = () => {
        setEnRollCourse(null);
        navigate("/register" , {state: { type: enroll }});
    };

    const handleLogIn = () => {
        setEnRollCourse(null);
        navigate("/login", { state: { type: enroll } });
    };

    if (!enroll) return null;

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/40"
            onClick={onBackdropClick}
            aria-hidden={false}
        >
            <div
                role="dialog"
                aria-modal="true"
                aria-labelledby="enroll-title"
                aria-describedby="enroll-desc"
                ref={modalRef}
                className="bg-white p-6 rounded-xl shadow-lg w-full max-w-md text-center relative mx-4"
                onClick={(e) => e.stopPropagation()} // prevent backdrop close when clicking inside
            >
                {/* close button (position absolute inside modal) */}
                <button
                    onClick={() => setEnRollCourse(null)}
                    aria-label="Close"
                    className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
                >
                    ✕
                </button>

                <h3 id="enroll-title" className="text-xl font-bold mb-3">
                    Wait — you’re not logged in
                </h3>

                <img
                    src={EnrollImg}
                    alt="People collaborating — login prompt"
                    className="mx-auto mb-4 w-full object-cover rounded-md"
                />

                <p id="enroll-desc" className="text-gray-600 mb-6">
                    Please log in or create an account to enroll and access full course features.
                </p>

                <div className="flex flex-col sm:flex-row justify-center gap-3 mt-2">
                    <button
                        ref={firstButtonRef}
                        onClick={handleSignUp}
                        className="border border-primary-600 text-primary-600 font-medium px-4 py-2 rounded-lg transition"
                    >
                        Sign Up
                    </button>

                    <button
                        onClick={handleLogIn}
                        className="bg-primary-600 hover:bg-primary-700 text-white font-medium px-4 py-2 rounded-lg transition"
                    >
                        Log In
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EnRoll;